import { useNode } from "@craftjs/core";
import { FormControlLabel, FormGroup, Switch, TextField } from "@mui/material";

import { BasicCarouselPreviewComponent } from "../basic/BasicCarouselPreviewComponent";
import { EventFiltersSettings } from "@components/EventFilterSettings";

interface PortraitCarouselProps {
  title: string;
  showActionButton?: boolean;
  actionButtonText?: string;
  categoryIDs?: string[];
  eventStatus?: string;
  keywords?: string[];
  startDate?: Date | null;
  endDate?: Date | null;
  connect?: any;
  drag?: any;
}

const PortraitCarouselBuilderComponent = (props: PortraitCarouselProps) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <PortraitCarouselPreviewComponent
      {...props}
      connect={connect}
      drag={drag}
    />
  );
};

export default PortraitCarouselBuilderComponent;

export const PortraitCarouselPreviewComponent = ({
  title,
  showActionButton,
  actionButtonText,
  connect,
  drag,
  categoryIDs,
  eventStatus,
  keywords,
  startDate,
  endDate,
}: PortraitCarouselProps) => {
  return (
    <div
      ref={(ref: any) => (connect && drag ? connect(drag(ref)) : undefined)}
      className="py-4"
    >
      <BasicCarouselPreviewComponent
        title={title}
        noPadding
        isPortrait
        showSeeMore={showActionButton}
        actionButtonText={actionButtonText}
        categoryIDs={categoryIDs}
        eventStatus={eventStatus}
        keywords={keywords}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  );
};

const PortraitCarouselSettings = () => {
  const {
    actions: { setProp },
    title,
    showActionButton,
    actionButtonText,
  } = useNode((node) => ({
    title: node.data.props.title,
    showActionButton: node.data.props.showActionButton,
    actionButtonText: node.data.props.actionButtonText,
  }));

  return (
    <div className="w-full space-y-4">
      <TextField
        fullWidth
        label="Title"
        value={title}
        onChange={(e) => setProp((prop: any) => (prop.title = e.target.value))}
      />

      <FormGroup>
        <FormControlLabel
          control={
            <Switch
              checked={showActionButton}
              color="primary"
              onChange={(e) => setProp((prop: any) => (prop.showActionButton = e.target.checked))}
            />
          }
          label="Show Action Button"
        />
      </FormGroup>

      {showActionButton && (
        <TextField
          fullWidth
          label="Action Button Text"
          value={actionButtonText}
          onChange={(e) => setProp((prop: any) => (prop.actionButtonText = e.target.value))}
        />
      )}

      {showActionButton && (
        <EventFiltersSettings
          includeCategories={true}
          includeEventStatus={true}
          includeKeywords={true}
          includeDateRange={true}
        />
      )}
    </div>
  );
};

PortraitCarouselBuilderComponent.craft = {
  props: {
    title: "Portrait Carousel",
    showActionButton: true,
    actionButtonText: "View Related",
    categoryIDs: [],
    eventStatus: null,
    keywords: [],
    startDate: null,
    endDate: null,
  },
  displayName: "Portrait Carousel",
  related: {
    settings: PortraitCarouselSettings,
  },
};
